import { Link } from "@tanstack/react-router";
import { Facebook, Mail, Phone } from "lucide-react";
import { SITE } from "@/config/site";

export function SiteFooter() {
  return (
    <footer className="mt-24 border-t border-border/60 bg-secondary/40">
      <div className="mx-auto grid max-w-7xl gap-8 px-4 py-12 sm:px-6 md:grid-cols-3">
        <div>
          <p className="font-script text-3xl text-primary">Surer Adda</p>
          <p className="mt-2 max-w-xs text-sm text-muted-foreground">
            Bookings for live performances, versatile singing, voiceover, voice dubbing and music albums across India.
          </p>
        </div>
        <div>
          <h2 className="mb-3 text-sm font-semibold uppercase tracking-wider">Explore</h2>
          <ul className="space-y-2 text-sm">
            <li><Link to="/events" className="hover:text-primary">Upcoming Events</Link></li>
            <li><Link to="/gallery" className="hover:text-primary">Photo Gallery</Link></li>
            <li><Link to="/blog" className="hover:text-primary">Blog</Link></li>
            <li><Link to="/about" className="hover:text-primary">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-primary">Contact Us</Link></li>
            <li><Link to="/enquiry" className="hover:text-primary">Send an Enquiry</Link></li>
            <li><Link to="/book" className="hover:text-primary">Book a Performance</Link></li>
            <li><Link to="/privacy" className="hover:text-primary">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-primary">Terms &amp; Conditions</Link></li>
            <li><Link to="/cookies" className="hover:text-primary">Cookie Policy</Link></li>
            <li><Link to="/disclaimer" className="hover:text-primary">Disclaimer</Link></li>
          </ul>
        </div>
        <div>
          <h2 className="mb-3 text-sm font-semibold uppercase tracking-wider">Connect</h2>
          <ul className="space-y-2 text-sm">
            <li className="flex items-center gap-2"><Mail className="h-4 w-4" /> {SITE.contact.email}</li>
            <li className="flex items-center gap-2"><Phone className="h-4 w-4" /> {SITE.contact.phone}</li>
            <li>
              <a href={SITE.facebookUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover:text-primary">
                <Facebook className="h-4 w-4" /> Facebook Page
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="space-y-1 border-t border-border/60 px-4 py-5 text-center text-xs text-muted-foreground">
        <p>© 2026 Surer Adda With Sanchayeeta</p>
        <p>Surer Adda With Sanchayeeta | Music, Live Performance &amp; Artist Booking Platform</p>
        <p>Sanchayeeta Seal — Live Performance Artist, Versatile Singer, Voice Artist, Voice Dubbing Artist &amp; Music Album Performer.</p>
        <p>All Rights Reserved.</p>
      </div>
    </footer>
  );
}
